import { Link } from "react-router-dom";
import { playZip } from "@/lib/zipSound";

const STYLES = {
    gold: "zip-gold bg-gold text-black",
    ghost: "zip-ghost border border-white/25 bg-transparent text-ink",
};

/* A button styled as a zipper — on hover the zip opens (teeth part, pull travels) and the label slides out. */
export default function ZipCTA({
    to,
    onClick,
    type = "button",
    children,
    variant = "gold",
    testid,
    className = "",
}) {
    const cls = `zip-btn group relative inline-flex h-14 items-center justify-center overflow-hidden px-8 ${STYLES[variant]} ${className}`;
    const content = (
        <>
            <span className="zip-teeth zip-teeth-top" aria-hidden="true" />
            <span className="zip-teeth zip-teeth-bottom" aria-hidden="true" />
            <span className="zip-pull" aria-hidden="true" />
            <span className="relative z-10 font-display text-sm font-bold uppercase tracking-[0.2em] transition-transform duration-500 group-hover:translate-x-1.5">
                {children}
            </span>
        </>
    );
    if (to) {
        return (
            <Link
                to={to}
                data-testid={testid}
                onClick={onClick}
                onMouseEnter={() => playZip({ rate: 1.6, volume: 0.06 })}
                className={cls}
            >
                {content}
            </Link>
        );
    }
    return (
        <button
            type={type}
            data-testid={testid}
            onClick={onClick}
            onMouseEnter={() => playZip({ rate: 1.6, volume: 0.06 })}
            className={cls}
        >
            {content}
        </button>
    );
}
